import dayjs, { Dayjs } from "dayjs";

export const convertDatetoDate = (date: string):Dayjs=>{

    
    const splitDate = date.split(" ")
    const formatDateArr =  splitDate[0].split("/")
    const formatDate = formatDateArr[2]+"-"+formatDateArr[1]+"-"+ formatDateArr[0]+"T"+splitDate[1]

    const newDate = dayjs(formatDate)

    return newDate

}